import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Mic } from "lucide-react";
import { api, formatApiError } from "../lib/api";

const LABEL = { requested: "Request received, we'll be in touch", invited: "Invited! Check your email to sign the guest release", signed: "Release signed, we'll schedule you", declined: "Not this season, thank you!" };

export function PodcastRequestCard() {
  const [mine, setMine] = useState(null);
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ topic: "", about: "", availability: "", links: "" });
  const load = () => api.get("/podcast/interview-requests/mine").then((r) => setMine(r.data)).catch(() => setMine([]));
  useEffect(() => { load(); }, []);
  async function send() {
    try { await api.post("/podcast/interview-requests", f); toast.success("Request sent! We'll reach out soon."); setOpen(false); load(); }
    catch (e) { toast.error(formatApiError(e)); }
  }
  const last = mine?.[0];
  return (
    <div className="bg-[var(--ink)] text-white rounded-3xl p-6" data-testid="podcast-request-card">
      <p className="font-serif text-2xl flex items-center gap-2"><Mic className="w-5 h-5 text-[var(--gold)]" /> Be on our podcast</p>
      <p className="text-sm text-white/70 mt-1">Share your love story, planning tips or business journey with Shawn & Brittney on the Locked In Forever podcast.</p>
      {last && last.status !== "declined" ? (
        <p className="text-sm mt-4 text-[var(--gold)]" data-testid="podcast-request-status">{LABEL[last.status] || last.status}</p>
      ) : !open ? (
        <button onClick={() => setOpen(true)} className="btn-gold mt-4 !py-2" data-testid="podcast-request-open">Request an interview</button>
      ) : (
        <div className="mt-4 space-y-2">
          <input value={f.topic} onChange={(e) => setF({ ...f, topic: e.target.value })} maxLength={160} placeholder="What would you like to talk about?" className="input-luxe !bg-white/10 !text-white" data-testid="podcast-request-topic" />
          <textarea value={f.about} onChange={(e) => setF({ ...f, about: e.target.value })} rows={3} maxLength={1500} placeholder="A little about you" className="input-luxe !bg-white/10 !text-white" data-testid="podcast-request-about" />
          <input value={f.availability} onChange={(e) => setF({ ...f, availability: e.target.value })} maxLength={200} placeholder="Best days/times" className="input-luxe !bg-white/10 !text-white" data-testid="podcast-request-availability" />
          <button onClick={send} disabled={f.topic.trim().length < 3} className="btn-gold !py-2" data-testid="podcast-request-submit">Send request</button>
        </div>
      )}
    </div>
  );
}
